import { Bell } from 'lucide-react';

interface NotificationEmptyProps {
  filter: 'all' | 'unread';
}

export function NotificationEmpty({ filter }: NotificationEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="rounded-full bg-gray-800 p-3 mb-4">
        <Bell className="h-6 w-6 text-white" />
      </div>
      <h3 className="text-lg font-medium text-white mb-1">
        No notifications yet
      </h3>
      <p className="text-sm text-muted-foreground text-center">
        {filter === 'unread' 
          ? "You're all caught up! No unread notifications."
          : "You'll receive your first notification after being approved to play the clubhouse."}
      </p>
    </div>
  );
}